import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Skeleton from '@empiriecom/module-components/Skeleton';

const SkeletonWrapper = styled.div`
  margin: 1.938rem auto 0;
  padding: 0 1.75rem;
  width: 100%;
  max-width: 48rem;
  height: 44.563rem;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: row nowrap;
  @media only screen and (max-width: 500px) {
    flex-flow: row wrap;
    height: 100%;
    margin: 0.5rem auto 0;
    padding: 0;
  }
`;

const ProductDetailsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: row wrap;
  width: 22.188rem;
  padding-right: 1.25rem;
  @media only screen and (max-width: 500px) {
    width: 100%;
    padding-right: 0;
  }
`;

const ImageAndDetailsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  @media only screen and (max-width: 500px) {
    flex-flow: row;
    padding: 0 0.75rem;
    width: 100%;
  }
`;

const ImageSkeleton = styled(Skeleton)`
  position: relative;
  width: 20.938rem;
  height: 20.938rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media only screen and (max-width: 500px) {
    width: 6.25rem;
    height: 6.25rem;
  }
`;

const DetailsSkeleton = styled(Skeleton)`
  width: 100%;
  margin-top: 1rem;
  @media only screen and (max-width: 500px) {
    margin-top: 0;
    width: auto;
    flex-grow: 1;
    margin-left: 1rem;
  }
`;

const ButtonWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;

const ButtonSkeleton = styled(Skeleton)`
  margin-top: 1rem;
  width: 100%;
  @media only screen and (max-width: 500px) {
    margin-bottom: 1rem;
  }
`;

const ContentWrapper = styled.div`
  ${({ theme }) => `border-left: 1px solid ${theme.greyNormal.color.normal}`};
  padding-left: 1rem;
  height: 100%;
  @media only screen and (max-width: 500px) {
    padding-left: 0;
    border: 0px none;
  }
  width: 100%;
`;

const ContentSkeleton = styled(Skeleton)`
  margin: 0 0 2.5rem;
  width: 100%;
`;

/**
 * This is the compact detail view skeleton. It provides a skeleton view of the compact detail view
 * elements until all information is loaded and ready to be displayed.
 */
export const CompactDetailViewSkeleton: FunctionComponent = (): JSX.Element => (
  <SkeletonWrapper>
    <ProductDetailsWrapper>
      <ImageAndDetailsWrapper>
        <ImageSkeleton height="20.938rem" />
        <DetailsSkeleton height="6.25rem" />
      </ImageAndDetailsWrapper>
      <ButtonWrapper>
        <ButtonSkeleton height="1.75rem" />
      </ButtonWrapper>
    </ProductDetailsWrapper>
    <ContentWrapper>
      <ContentSkeleton height="5rem" />
      <ContentSkeleton height="5rem" />
      <ContentSkeleton height="5rem" />
      <ContentSkeleton height="5rem" />
      <ContentSkeleton height="5rem" />
    </ContentWrapper>
  </SkeletonWrapper>
);

export default CompactDetailViewSkeleton;
